import { useEffect } from 'react';
import { getGAClientId } from 'src/utils/DataLayerUtil';

import { usePixelStreamingContext } from '../contexts/PixelStreamingContext';

export default function useInitialPacket(
  metaverseId: string | undefined,
  organizationId: string | undefined,
  authToken: string | undefined,
  user: any,
) {
  const { descriptor, emitUIInteraction } = usePixelStreamingContext();
  useEffect(() => {
    console.debug({
      emitUIInteraction: !!emitUIInteraction,
      descriptor: !!descriptor,
      metaverseId: !!metaverseId,
      authToken: !!authToken,
      user: !!user,
    });
    if (!emitUIInteraction || !descriptor || !metaverseId || !authToken || !user) {
      return () => {};
    }
    emitUIInteraction({
      type: 'initial',
      userId: user.userId,
      token: authToken,
      metaverseId,
      organizationId,
      apiUrl: window.location.origin,
      gaClientId: getGAClientId(),
    });
  }, [descriptor, emitUIInteraction, metaverseId, authToken, user]);
}
